import { defineMessages } from 'react-intl';

const messages = defineMessages({
  optional: {
    id: 'optional',
    defaultMessage: '(Optional)'
  }
});

export default messages;
